import { css, cx } from '@emotion/css';
import { Tabs } from 'antd';
import { Font, Spacing } from 'src/styles';

interface MTabsProps {
  items: Array<{
    key: string;
    label: string;
    children: React.ReactNode;
  }>;
  className?: string;
}

const tabs = css`
  .ant-tabs-tab-btn {
    ${Font.h5}
  }

  &.ant-tabs-top > .ant-tabs-nav,
  &.ant-tabs-top > div > .ant-tabs-nav {
    ${Spacing.mb12}
  }
`;

export const MTabs = ({ items, className }: MTabsProps) => {
  return <Tabs items={items} className={cx(tabs, className)} />;
};
